import React, { useState } from 'react';
import axios from 'axios';
import AudioPlayer from './AudioPlayer';

const ReadAloudButton = ({ text, voice = "nova", serviceType = "general" }) => {
  const [audioUrl, setAudioUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleReadAloud = async () => {
    if (audioUrl) {
      // If audio already loaded, just show player again
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/tts/generate`,
        { text, voice, service_type: serviceType },
        { withCredentials: true }
      );

      setAudioUrl(response.data.audio_url);
    } catch (err) {
      console.error('TTS error:', err);
      setError('Failed to generate audio');
      setTimeout(() => setError(null), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setAudioUrl(null);
  };

  return (
    <div className="inline-block">
      {!audioUrl ? (
        <button
          type="button"
          onClick={handleReadAloud}
          disabled={isLoading || !text}
          className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-blue-700 bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-lg transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
          title={!text ? "No content to read aloud" : "Read this section aloud"}
        >
          {isLoading ? (
            <>
              <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
              </svg>
              <span>Loading...</span>
            </>
          ) : (
            <>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15.586a2 2 0 001.414.586h2.172a2 2 0 001.414-.586l.707-.707M5 11h8" />
              </svg>
              <span>Read Aloud</span>
            </>
          )}
        </button>
      ) : (
        <AudioPlayer audioUrl={audioUrl} onClose={handleClose} />
      )}
      
      {error && (
        <div className="mt-1 text-xs text-red-600">
          {error}
        </div>
      )}
    </div>
  );
};

export default ReadAloudButton;
